import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Restringe un árbol de rutas a ciertos roles. Debe usarse dentro de un
 * `<ProtectedRoute>` (asume que ya hay sesión iniciada).
 *
 * @param {{ allowedRoles: string[] }} props
 */
export default function RoleRoute({ allowedRoles }) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
